<div>
    
    <h2 class="m-b-5" mat-dialog-title>Comentario</h2>
    <form [formGroup]="ComentarioFormGroup.get('Gestion')">
        <div mat-dialog-content id="leave-popup-fields">
            <div class="m-b-5">
                <mat-checkbox formControlName="Interno" >Interno</mat-checkbox>
            </div>
            <div class="m-b-5 comentario-bx">
                <mat-label>Comentario</mat-label>
                <textarea matInput placeholder="Comentario:" formControlName="Comments"></textarea>
    
            </div>
            <div class="text-a-r p-t-5">
                <button mat-raised-button color="accent" class="m-r-15" (click)="Crate()">Consultar</button>
                <button mat-raised-button color="warn" (click)="cancel()" >Cancelar</button>
            </div>
        </div>
    </form>
    
</div>